import React, { useMemo, useRef, useState } from "react";
import { Outlet } from "react-router-dom";
import { PeekBox, PeekStack } from "@piiqtechnologies/ui-components";
import { AppSidebar } from "@components/common/app-sidebar";
import { SidebarNavProvider } from "@stores/SidebarNavContext";
import { SubjectReportsProvider } from "@stores/SubjectReportsContext";
import { AppShellContext } from "./AppShellContext";
export const DashboardLayout = () => {
    const scrollContainerRef = useRef(null);
    const [headerSlot, setHeaderSlot] = useState(null);
    const appShell = useMemo(() => ({ scrollContainerRef, headerSlot }), [headerSlot]);
    return (React.createElement(AppShellContext.Provider, { value: appShell },
        React.createElement(SidebarNavProvider, null,
            React.createElement(SubjectReportsProvider, null,
                React.createElement(PeekStack, { direction: "row", sx: { width: "100%", height: "100vh" } },
                    React.createElement(AppSidebar, null),
                    React.createElement(PeekStack, { sx: { p: 3, flex: 1, minHeight: 0, backgroundColor: "grey.50" } },
                        React.createElement(PeekBox, { ref: setHeaderSlot }),
                        React.createElement(PeekBox, { ref: scrollContainerRef, sx: { flex: 1, minHeight: 0, overflowY: "auto", scrollbarWidth: "auto", pr: "10px" } },
                            React.createElement(Outlet, null))))))));
};
export default DashboardLayout;
